module.exports = __webpack_public_path__ + "img/AggregateFunction.e7c9e11c.svg";